import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { AuthService } from '../../../services/auth/auth.service';
import { Component, OnInit } from '@angular/core';
import { AuthPageManageService } from '../../../services/manage/page-manage/auth-page-manage.service';
import { ToolsService } from '../../../services/tools/tools.service';
import {CssService} from "../../../services/css-service";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  forgotPassForm: FormGroup |any;
  error$: string|any;
  currEmail: string|any;

  loaderForgotPass: boolean = false;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    public cssService: CssService,
    public authManPag: AuthPageManageService,
    private tools: ToolsService,
  ) { }

  ngOnInit() {
    this.forgotPassForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
    this.authService.getError.subscribe(data => {
      this.error$ = data;
    })

  }

  createForgotPassForm() {
    this.forgotPassForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  isFieldrequired(field: string) {
    let thisField = this.forgotPassForm.controls[field];
    if (thisField.errors) {
      if (thisField.errors.required) {
        return true;
      }
    }
    return
  }

  submitResetPass(formDirective: FormGroupDirective) {
    let that = this;
    let formVal = that.forgotPassForm.value;
    that.error$ = "";

    if (that.forgotPassForm.valid) {
      that.loaderForgotPass = true;
      that.currEmail = formVal.email;
      that.authService.forgotPassMail(formVal.email).then(function () {
        that.loaderForgotPass = false;
        that.tools.resetForm(formDirective, that.forgotPassForm);
      })
    }
  }


}
